export const ManageMySiteEditTestIDs = {
  scrollView: 'manage-my-site-scroll-view',
  overlay: 'manage-my-site-edit-overlay',
  contentView: 'manage-my-site-edit-content-view',
  errorBanner: {
    container: 'manage-my-site-error-banner',
    icon: 'manage-my-site-error-banner-icon',
    textWrapper: 'manage-my-site-error-banner-text-wrapper',
    text: 'manage-my-site-error-banner-text',
  },

  sections: {
    avatar: 'manage-my-site-avatar-section',
    website: 'manage-my-site-website-section',
    contact: 'manage-my-site-contact-section',
    address: 'manage-my-site-address-section',
    about: 'manage-my-site-about-section',
    photos: 'manage-my-site-photos-section',
  },

  footer: {
    cancelButton: 'manage-my-site-cancel-button',
    saveButton: 'manage-my-site-save-button',
  },
};
export default ManageMySiteEditTestIDs;
